import $ from "jquery";
import TabManager from "../customTabComponent/customTabComponent";

const bannerComponent = {
    variable: {
        imageComponent: ".banner__image__container--image",
        contentComponent: ".banner__content__container--main-text",
        termComponent: ".terms__text",
        uspWrapper: ".banner__usp-wrapper",
        tabWrapperId: "#banner__tab",
        url: window.location.href,
        bannerTitleComponent: $('.banner__content__container--main-text__title'),
        chliTitleComponent: $('.chlititle_container--main_text__title'),
    },
    methods: {
        updateImageContent: function (tabItem) {
            $(bannerComponent.variable.imageComponent).removeClass("active-image prev-active-image next-active-image");
            $(bannerComponent.variable.imageComponent + "[data-imgid='" + tabItem.id + "']").addClass("active-image");
            $(bannerComponent.variable.imageComponent + "[data-imgid='" + tabItem.id + "']")
                .prev()
                .addClass("prev-active-image");
            $(bannerComponent.variable.imageComponent + "[data-imgid='" + tabItem.id + "']")
                .next()
                .addClass("next-active-image");
        },
        updateTextContent: function (tabItem) {
            $(bannerComponent.variable.contentComponent).removeClass("active-text prev-active-text next-active-text");
            $(bannerComponent.variable.contentComponent + "[data-textid='" + tabItem.id + "']").addClass("active-text");
            $(bannerComponent.variable.contentComponent + "[data-textid='" + tabItem.id + "']")
                .prev()
                .addClass("prev-active-text");
            $(bannerComponent.variable.contentComponent + "[data-textid='" + tabItem.id + "']")
                .next()
                .addClass("next-active-text");
            let bannerName = document.querySelector(".active-text .banner__content__container--main-text__title").innerText;
            let bannerType = tabItem.id;
            let buttonName = tabItem.innerText.replace(/\n/g, '').trim();
            let bannerImages = $(".banner__image__container--image");
            let pageSection=tabItem.textContent.replace(/\n/g, '').trim();
            let str='Form_';
            var obj = bannerComponent.methods.dataLayerObj(bannerName, bannerType, buttonName,str.concat(pageSection));
            createDataLayer('buttonClick', obj);
        },
        updateTermContent: function (tabItem) {
            $(bannerComponent.variable.termComponent).removeClass("active-term prev-active-term next-active-term");
            $(bannerComponent.variable.termComponent + "[data-termid='" + tabItem.id + "']").addClass("active-term");
            $(bannerComponent.variable.termComponent + "[data-termid='" + tabItem.id + "']")
                .prev()
                .addClass("prev-active-term");
            $(bannerComponent.variable.termComponent + "[data-termid='" + tabItem.id + "']")
                .next()
                .addClass("next-active-term");
        },
        updateSliderContent: function (tabItem) {
            $(bannerComponent.variable.uspWrapper).removeClass("active-usp prev-active-usp next-active-usp");
            $(bannerComponent.variable.uspWrapper + "[data-uspid='" + tabItem.id + "']").addClass("active-usp");
            $(bannerComponent.variable.uspWrapper + "[data-uspid='" + tabItem.id + "']")
                .prev()
                .addClass("prev-active-usp");
            $(bannerComponent.variable.uspWrapper + "[data-uspid='" + tabItem.id + "']")
                .next()
                .addClass("next-active-usp");
        },
        handleTextCtaButtonClick: function () {
            $(document).on("click", ".banner__text-cta--btn", function () {
                let bannerName = document.querySelector(".active-text .banner__content__container--main-text__title")?.innerText || "";
                let bannerType = $(this).closest(".tab__pane").data("id") || "";
                let buttonName = $(this).text().replace(/\n/g, '').trim().replace(/\s*\(?opens in a new tab\)?\s*/i, '');
                let pageSection = $(".tab__navigations--item.active-tab .tab__navigations--item__title").text().replace(/\n/g, '').trim();
                let str = 'Form_';
                let productCategory = $(this).data('product-category') || "";
                let productName = $(this).data('product-name') || "";
                var obj = bannerComponent.methods.dataLayerObj(bannerName, bannerType, buttonName, str.concat(pageSection), productCategory, productName);
                createDataLayer('buttonClick', obj);
            });
        },
        handleTitleFont: function() {
            const bannerTitle = bannerComponent.variable.bannerTitleComponent;

            const titleColor = bannerTitle.data('title-color');
            const desktopFont = bannerTitle.data('desktop-font');
            const tabletFont = bannerTitle.data('tablet-font');
            const mobileFont = bannerTitle.data('mobile-font');

            // matchMedia gives the same answer as window.innerWidth <= N (both use the
            // viewport width incl. scrollbar) but never forces a synchronous layout.
            let fontSize = desktopFont;

            if (window.matchMedia("(max-width: 576px)").matches) {
                fontSize = mobileFont;
            } else if (window.matchMedia("(max-width: 992px)").matches) {
                fontSize = tabletFont;
            }

            bannerTitle.css('font-size', `${fontSize}px`);
            bannerTitle.css('color', `${titleColor}`);
        },
        handleChliTitleFont: function() {
            const bannerTitles = bannerComponent.variable.chliTitleComponent;
            // matchMedia instead of window.innerWidth: same breakpoints, no forced layout
            // (this ran right after handleTitleFont() wrote styles, forcing a full reflow).
            const isMobile = window.matchMedia("(max-width: 576px)").matches;
            const isTablet = window.matchMedia("(max-width: 992px)").matches;

          bannerTitles.each(function () {
            const $title = $(this);

            const desktopFont = $title.data('desktop-font');
            const tabletFont = $title.data('tablet-font');
            const mobileFont = $title.data('mobile-font');

            let fontSize = desktopFont;

            if (isMobile) {
              fontSize = mobileFont;
            } else if (isTablet) {
              fontSize = tabletFont;
            }

            $title.css('font-size', `${fontSize}px`);
          });
        },
        // The banner has a fixed height and its content layer is position:absolute,
        // so when text is enlarged (accessibility widget, or WCAG 1.4.12 text
        // spacing) the content grows past the banner and overlaps the next section.
        // Authors already reserve room for the *default* overflow (e.g. the next
        // Generic Container's mobile padding-top), so we only add the EXTRA growth
        // as margin below the banner. At default text size this adds nothing.
        handleTextResize: function () {
            const ENLARGED_CLASS = "banner--text-enlarged";

            document.querySelectorAll("section.banner").forEach(function (section) {
                const wrapper = section.querySelector(".banner__content__wrapper");
                if (!wrapper || typeof ResizeObserver === "undefined") {
                    return;
                }
                let timer = null;

                // Bottom of the content itself (scrollHeight), not of the wrapper box —
                // in the 1200-1400px band the wrapper has a fixed height and the
                // content overflows inside it.
                function overflow() {
                    const contentBottom = wrapper.getBoundingClientRect().top + wrapper.scrollHeight;
                    return contentBottom - section.getBoundingClientRect().bottom;
                }

                function update() {
                    const body = document.body;
                    section.style.marginBottom = "";
                    section.classList.remove(ENLARGED_CLASS);

                    // Measure the default-size overflow by briefly removing the
                    // widget's text classes. Synchronous, so nothing is painted.
                    const textClasses = Array.prototype.filter.call(body.classList, function (c) {
                        return c.indexOf("dwas-") === 0;
                    });
                    textClasses.forEach(function (c) { body.classList.remove(c); });
                    const baseOverflow = overflow();
                    textClasses.forEach(function (c) { body.classList.add(c); });

                    if (overflow() - baseOverflow <= 1) {
                        return;
                    }
                    // Lets the 1200-1400px layout flow instead of pinning the usp row
                    section.classList.add(ENLARGED_CLASS);
                    const extra = overflow() - Math.max(baseOverflow, 0);
                    if (extra > 1) {
                        section.style.marginBottom = `${Math.ceil(extra)}px`;
                    }
                }

                const observer = new ResizeObserver(function () {
                    clearTimeout(timer);
                    timer = setTimeout(update, 50);
                });
                // Watch the children too: a fixed-height wrapper doesn't resize
                // when only its content grows.
                observer.observe(wrapper);
                Array.prototype.forEach.call(wrapper.children, function (child) {
                    observer.observe(child);
                });
            });
        },
        init: function () {
            this.handleTextCtaButtonClick();
            this.handleTitleFont();
            this.handleChliTitleFont();
            this.handleTextResize();
            // Drive the banner's own image/text/term/usp swap from the SAME
            // click TabManager already listens for, instead of a second
            // independent $(document).on(click) handler on the same tab
            // items — that used to mean two full DOM update passes per
            // click (visible as lag, especially on mobile).
            const tabManager = new TabManager("banner__tab", function (tabItem) {
                bannerComponent.methods.updateImageContent(tabItem);
                bannerComponent.methods.updateTextContent(tabItem);
                bannerComponent.methods.updateTermContent(tabItem);
                bannerComponent.methods.updateSliderContent(tabItem);
            });
            tabManager.init();
        },
        dataLayerObj : function(bannerName, bannerType, buttonName, pageSection, productCategory, productName) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : buttonName ? buttonName : "",
                'pageSection' : pageSection ? pageSection :"",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? bannerComponent.variable.url.includes("blog") ? "Blogs" : bannerComponent.variable.url.substring(bannerComponent.variable.url.indexOf(".com/"), bannerComponent.variable.url.lastIndexOf('/')  === ".com") && !bannerComponent.variable.url.substring(bannerComponent.variable.url.indexOf(".com/"), bannerComponent.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : productCategory ? productCategory : "",
                'productName' : productName ? productName : "",
                'question' : "",
                'searchTerm' : "",
                'videoTitle' : "",
            };
            return obj;
        }
    },
};

if ($(".banner").length > 0) {
    bannerComponent.methods.init();
    if ($('.banner').attr('data-hideTabVariant') == 'true') {
        let wrapper = $('<div>').addClass('generic-form__frame--inner');
        $('.tab__pane').hide();
        $('.tab__pane:first .generic-form__group').each(function() {
            $(this).appendTo(wrapper);
        });
        $('.tab__pane:first').show();
        $('.generic-form__frame').prepend(wrapper);
    }
} else {
   bannerComponent.methods.handleChliTitleFont();
}
